import { render, staticRenderFns } from "./OverworkDialog.vue?vue&type=template&id=23dc3daa"
import script from "./OverworkDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverworkDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports